/**
 * Give an HTTP client the methods that call Wayfinder helpers, which
 * carry both the URL and the verb; the remaining arguments are axios' own
 * (`data`, `config`).
 *
 * - `route(helper, ...args)` sends the helper's verb:
 *   `apiClient.route(DossierController.update.put({ dossier }), payload)`
 * - `formRoute(helper, data, config)` POSTs and spoofs the helper's verb in
 *   `_method`, for PUT/PATCH/DELETE routes that receive files (PHP only
 *   parses multipart bodies on POST):
 *   `apiClient.formRoute(SiteController.update.put({ site }), formData)`
 *
 * @template {object} Client
 * @param {Client} client
 * @returns {Client}
 */
export function addRouteCall(client) {
  client.route = (route, ...args) => client[route.method](route.url, ...args)

  client.formRoute = (route, data, ...args) => {
    const spoofedMethod = route.method.toUpperCase()

    if (data instanceof FormData) {
      data.set('_method', spoofedMethod)
      return client.post(route.url, data, ...args)
    }

    return client.post(route.url, { ...data, _method: spoofedMethod }, ...args)
  }

  return client
}
